<h2 mat-dialog-title class="add-keywords-title">
  {{ 'LOCAL_SEO.ADD_KEYWORDS' | translate }}
  <glxy-badge [color]="currentKeywordUsage() < keywordLimit ? 'green' : 'grey'">
    {{ currentKeywordUsage() }}/{{ keywordLimit }} {{ 'LOCAL_SEO.USED' | translate }}
  </glxy-badge>
</h2>
<mat-dialog-content>
  <mat-list *ngIf="this.data.keywords.length < keywordLimit">
    <forms-va-input-repeated
      [controlArray]="form"
      [placeholder]="'LOCAL_SEO.ADD_A_KEYWORD' | translate"
      [label]="'LOCAL_SEO.KEYWORD.TITLE' | translate"
      [addText]="'LOCAL_SEO.ADD_A_KEYWORD' | translate"
      [maxFields]="keywordLimit - data?.keywords?.length"
      [disableAdd]="form.length >= keywordLimit"
      [bottomSpacing]="'small'"
      (removeClicked)="removeClicked($event)"
    ></forms-va-input-repeated>
  </mat-list>
  <ng-container *ngIf="(isLbFreeEdition$ | async) === false">
    <glxy-label class="smart-suggestions">{{ 'LOCAL_SEO.SMART_SUGGESTIONS' | translate }}</glxy-label>
    <ng-container *ngIf="suggestedKeywordList?.length > 0; else noKeywords">
      <table mat-table [dataSource]="suggestedKeywordList">
        <ng-container matColumnDef="keyword">
          <th mat-header-cell *matHeaderCellDef class="column-cell">KEYWORD</th>
          <td mat-cell *matCellDef="let element">{{ element?.keyword }}</td>
        </ng-container>
        <ng-container matColumnDef="competition">
          <th mat-header-cell *matHeaderCellDef class="column-cell">COMPETITIVENESS</th>
          <td mat-cell *matCellDef="let element">{{ element?.competition | titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="search_volume">
          <th mat-header-cell *matHeaderCellDef class="column-cell">SEARCH VOLUME</th>
          <td mat-cell *matCellDef="let element">
            {{ element.searchVolume ? element.searchVolume.toLocaleString() : '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="add_button">
          <th mat-header-cell *matHeaderCellDef class="column-cell"></th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [disabled]="data?.keywords.length + form.controls.length > keywordLimit || !canEditKeywords"
              (click)="addSuggestedKeyword(element)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-container>
  </ng-container>
  <ng-template #noKeywords>
    @if (this.suggestedKeywordsErrorMessage) {
      <p>{{ suggestedKeywordsErrorMessage }}</p>
    } @else {
      <p>{{ 'LOCAL_SEO.NO_KEYWORDS_AVAILABLE' | translate }}</p>
    }
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeModal(false)">{{ 'COMMON.CANCEL' | translate }}</button>
  <button
    mat-flat-button
    color="primary"
    (click)="closeModal(true)"
    [disabled]="!(keywordLimit > data?.keywords.length && canEditKeywords)"
  >
    {{ 'COMMON.ADD_KEYWORDS' | translate }}
  </button>
</mat-dialog-actions>
